import React from 'react';

import { useAffiliateSettings, useCurrentUser } from '../../../../hooks';
import { MONTHLY_PLAN } from '../../../../utils/backend-api/subscribe';
import { LinkCopy, Spinner } from '../../../BaseUI';
import SettingsHeading from '../SettingsHeading';
import ReferralPaymentForm from './ReferralPaymentForm';
import styles from './styles.module.css';

const INITIAL_VALUES = {
  paymentType: {
    label: '',
    value: '',
  },
  paymentId: '',
};

const Affiliate = () => {
  const { currentUser, isLoadingCurrentUser } = useCurrentUser();
  const { affiliateSettings, isLoadingAffiliateSettings } = useAffiliateSettings();

  return (
    <>
      {isLoadingCurrentUser || isLoadingAffiliateSettings ? (
        <Spinner />
      ) : (
        <>
          <SettingsHeading title="Referral Program" />
          {currentUser?.settings_access_obj?.referral_access &&
          currentUser.subscription?.plan_type != MONTHLY_PLAN ? (
            <div>
              <div className={styles.referralHeader}>
                The Information offers subscribers $50 cash for every person you invite that signs
                up for an annual plan.
              </div>
              <div className={styles.affiliateLinkContainer}>
                <div className={styles.affiliateLinkContent}>
                  <div className={styles.affiliateTiShareDesc}>
                    <p>Your custom invite Link</p>
                  </div>
                  <LinkCopy
                    clipboardLink={currentUser.referral_url}
                    trackingProps={{
                      link: 'Settings Affiliate Referral Link - Click on Referral Link',
                    }}
                  />
                </div>
              </div>
              <div className={styles.affiliateLinkDescription}>
                To get paid your referral cash please select which payout option you want and your
                handle
              </div>
              <ReferralPaymentForm
                initialValues={{
                  ...INITIAL_VALUES,
                  paymentId: affiliateSettings.paymentId || '',
                  paymentType: {
                    label: affiliateSettings.paymentType.label || '',
                    value: affiliateSettings.paymentType.value || '',
                  },
                }}
              />
            </div>
          ) : (
            <div className={styles.affiliateLinkDescription}>
              The Information offers subscribers $50 cash for every person you invite that signs up
              for an annual plan. You do not currently have access to this program as a non yearly
              subscriber, but if you would like to get access email{' '}
              <a className={styles.blueLink} href="mailto:support@theinformation.com">
                support@theinformation.com
              </a>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default Affiliate;
